import { CustomFields } from '../../../cimsPage/instances/admin'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const customFields = CreateViewEditSoftRemoveRestore({
  page: CustomFields,
  object: 'Custom Field',
  view: '88E90070-A463-4B9B-AF35-33307A436D37',
  create: 'B8640A0F-80C9-4825-9BD2-5A31C04E7446',
  edit: 'E3E9D221-BD6E-4DCA-AC90-6117D986EB46',
  removeRestore: 'EB23CFAE-4034-440C-8D48-8687B1DD03D2',
})

export const ViewCustomField = customFields.View
export const CreateCustomField = customFields.Create
export const EditCustomField = customFields.Edit
export const RemoveRestoreCustomField = customFields.RemoveRestore

export type CustomFieldPermission =
  | typeof ViewCustomField
  | typeof CreateCustomField
  | typeof EditCustomField
  | typeof RemoveRestoreCustomField
